import { BaseComponent } from "./components/BaseComponent";

export class TrainEvaluationParameters{
    id:number;
    name:string;
    doors:Array<BaseComponent>;
    areaSelection:Array<string>
}